<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap_section">Maps</h2>
<p class="illust"><span class="illus">1.</span> The Helder</p>
<p class="illust"><span class="illus">2.</span> The landing at Callantsoog</p>
<p class="illust"><span class="illus">3.</span> The Battle of Krabbendam, showing the Franco-Batavian attack and the British position on the Zype Canal</p>
<p class="illust"><span class="illus">4.</span> The Battle of Bergen</p>
<p class="illust"><span class="illus">5.</span> The Battle of Egmond</p>
<p class="illust"><span class="illus">6.</span> The Battle of Castricum</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Maps.vue?123ca6e2